// extracted by mini-css-extract-plugin
export default {"result":"dAZQkb6L","mobile":"mobile","_centered":"VMIx7GmN","text":"Cz3IPH45","link":"klR0uAkj"};